import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "../../../../connectui/component/layout/FlexContainer";
import Text from "../../../../connectui/component/display/Text";
import SvgIcon from "../../../../connectui/component/display/SvgIcon";

const DashboardEmptyStateCard = ({
  text,
  icon,
  action = null,
  height = "200px",
}) => {
  const {theme} = useTheme();

  return (
    <FlexContainer
      width="100%"
      height={height}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={theme.spacing(5)}
      sx={{
        width: "100%",
      }}
    >
      <SvgIcon
        component={icon}
        sx={{
          width: "120px",
          height: "120px",
        }}
      />
      <Text
        variant="textSM"
        color="textSecondary"
        weight="medium"
        sx={{textAlign: "center"}}
      >
        {text}
        {"  "}
        <span
          style={{
            color: theme.colors.primary,
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onMouseEnter={(e) => (e.target.style.opacity = "0.8")}
          onMouseLeave={(e) => (e.target.style.opacity = "1")}
          onClick={() => {
            if (window.Intercom) {
              window.Intercom("showArticle", "11556870");
            }
          }}
        >
          Learn More
        </span>
      </Text>
      {action}
    </FlexContainer>
  );
};

export default DashboardEmptyStateCard;
